import "./ResultsList.scss";
import DetailProduct from "components/detail-product/DetailProduct";
import useComponentVisible from "utils/useComponentVisible";

const ResultsList = ({ results, title, couple }) => {
  const { ref, isComponentVisible, open, close } = useComponentVisible(false);
  const safeResults = Array.isArray(results) ? results : [];

  const renderSingleProducts = () => (
    <div className="results-list">
      {safeResults.length > 0 ? (
        <div className="result-product-table">
          <div className="table-header">
            <div className="header-info-block">
              <span>Code</span>
              <span>Name</span>
              <span>Description</span>
            </div>
            <div className="header-action-block">
              <span className="sr-only">Action</span>
            </div>
          </div>
          <div className="table-body">
            {safeResults.map((element, index) => (
              <div className="table-row" key={`${element?.code || index}`}>
                <div className="row-info-block">
                  <span className="info-code" data-label="Code">
                    {element?.code || "-"}
                  </span>
                  <span className="info-name" data-label="Name">
                    {element?.name || "-"}
                  </span>
                  <span className="info-description" data-label="Description">
                    {element?.description || "-"}
                  </span>
                </div>
                <div className="row-action-block">
                  <div className="btn table" onClick={() => open(element)}>
                    Details
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="no-products-message">
          No products found for this configuration.
        </div>
      )}
    </div>
  );

  const renderCoupleProducts = () => {
    if (safeResults.length === 0) {
      return (
        <div className="no-products-message">
          No products found for this configuration.
        </div>
      );
    }

    const getCoupleCode = (element) => {
      const primary = element?.couple?.[0] || {};
      return (
        element?.code ||
        primary?.description ||
        primary?.picture ||
        primary?.name ||
        primary?.code ||
        "-"
      );
    };

    return (
      <div className="results-list-couple">
        {safeResults.map((element, index) => (
          <div className="results-couple" key={`${element?.code || index}`}>
            <div className="result-product-table-couple">
              <div className="table-header">
                <div className="header-code-block">Code</div>
                <div className="header-action-block">
                  <span className="sr-only">Action</span>
                </div>
              </div>
              <div className="table-body">
                <div className="table-row">
                  <div className="row-code-block" data-label="Code">
                    {`${getCoupleCode(element)} COMPONENTS`}
                  </div>
                  <div className="row-action-block">
                    <div
                      className="btn table"
                      onClick={() =>
                        open(
                          (element?.couple && element.couple[0]) ||
                            element ||
                            null
                        )
                      }
                    >
                      Details
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="results-view__results-list">
      {isComponentVisible && (
        <DetailProduct
          propRef={ref}
          product={isComponentVisible}
          close={close}
        />
      )}

      {!couple ? renderSingleProducts() : renderCoupleProducts()}
    </div>
  );
};

export default ResultsList;
